import QueryString from "qs";
import dynamic from "next/dynamic";
import Layout from "../layout/Layout";

const TemplatePages = dynamic(() =>
	import("../components/TemplatePages/TemplatePages")
);
const Itempage = dynamic(() => import("../components/pages/ItemPage"));
const ServicePage = dynamic(() => import("../components/pages/ServicePage"));
const TechnologyPage = dynamic(() =>
	import("../components/pages/TechnologyPage")
);
const IndustryPage = dynamic(() => import("../components/pages/IndustryPage"));
const StartUpPage = dynamic(() => import("../components/pages/StartUpPage"));
const BlogPage = dynamic(() => import("../components/pages/BlogPage"));
const CaseStudyPage = dynamic(() =>
	import("../components/pages/CaseStudyPage")
);
const GhostPage = dynamic(() => import("../components/pages/GhostPage"));
const UseCasePage = dynamic(() => import("../components/pages/UseCasePage"));
const CrmPage = dynamic(() => import("../components/pages/CrmPage"));

let baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

const components = {
	Itempage: Itempage,
	ServicePage: ServicePage,
	TechnologyPage: TechnologyPage,
	IndustryPage: IndustryPage,
	StartUpPage: StartUpPage,
	BlogPage: BlogPage,
	CaseStudyPage: CaseStudyPage,
	TemplatePage: TemplatePages,
	UseCasePage: UseCasePage,
	GhostPage: GhostPage,
	CrmPage: CrmPage,
};

export const getServerSideProps = async (ctx) => {
	const referer = ctx?.req?.headers?.referer || "";
	if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
		ctx.res.setHeader(
			"Cache-Control",
			"public, s-maxage=1800, stale-while-revalidate=59"
		);
	}
	const slug = ctx.params.slug;

	if (slug.includes("request-for-quote-proposal")) {
		return {
			redirect: {
				permanent: false,
				destination: "/request-proposal",
			},
		};
	}
	if (slug === "home") {
		return {
			redirect: {
				permanent: true,
				destination: "/",
			},
		};
	}

	const res = await fetch(`${baseUrl}get-component-by-slug/${slug}`);

	const component = await res.text();

	let apiRes = null;
	let apiResData = null;
	const query = QueryString.stringify(
		{
			filters: {
				slug: {
					$eq: slug,
				},
			},
			populate: "deep, 8",
		},
		{
			encodeValuesOnly: false,
		}
	);

	switch (component) {
		case "Itempage":
			apiRes = await fetch(
				`${baseUrl}pages?${decodeURIComponent(query)}`
			);
			break;
		case "ServicePage":
			if (slug !== "services") {
				return {
					redirect: {
						permanent: true,
						destination: `/services/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}services?${decodeURIComponent(query)}`
			);
			break;
		case "TechnologyPage":
			if (slug !== "technologies") {
				return {
					redirect: {
						permanent: true,
						destination: `/technologies/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}technologies?${decodeURIComponent(query)}`
			);
			break;
		case "IndustryPage":
			if (slug !== "industries") {
				return {
					redirect: {
						permanent: true,
						destination: `/industries/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}industries?${decodeURIComponent(query)}`
			);
			break;
		case "StartUpPage":
			if (slug !== "startups") {
				return {
					redirect: {
						permanent: true,
						destination: `/startups/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}startup-solutions?${decodeURIComponent(query)}`
			);
			break;
		case "BlogPage":
			if (slug !== "blog") {
				return {
					redirect: {
						permanent: true,
						destination: `/blog/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}articles?${decodeURIComponent(query)}`
			);
			break;
		case "UseCasePage":
			if (slug !== "use-cases") {
				return {
					redirect: {
						permanent: true,
						destination: `/use-cases/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}use-cases?${decodeURIComponent(query)}`
			);
			break;
		case "CrmPage":
			if (slug !== "solutions") {
				return {
					redirect: {
						permanent: true,
						destination: `/solutions/${slug}`,
					},
				};
			}
			apiRes = await fetch(
				`${baseUrl}crm-pages?${decodeURIComponent(query)}`
			);
			break;
		case "CaseStudyPage":
			if (slug !== "case-studies") {
				return {
					redirect: {
						permanent: true,
						destination: `/case-studies/${slug}`,
					},
				};
			}
			// apiRes = await fetch(`${baseUrl}case-studies?${decodeURIComponent(query)}`);
			apiRes = await fetch(
				`${baseUrl}case-studies-v2?${decodeURIComponent(query)}`
			);
			break;
		case "TemplatePage":
			apiRes = await fetch(
				`${baseUrl}template-pages?${decodeURIComponent(query)}`
			);
			break;
		case "GhostPage":
			apiRes = await fetch(
				`${baseUrl}ghost-pages?${decodeURIComponent(query)}`
			);
			break;
		default:
			return {
				notFound: true,
			};
	}

	if (apiRes) {
		apiResData = await apiRes.json();
	}
	const isNew = apiResData?.data?.[0]?.attributes?.design === "new";

	return {
		props: {
			component,
			apiResData,
			slug,
			referer,
			isNew: apiResData.data[0].attributes.design === "new",
		},
	};
};

// let NewComponent = null;
const DynamicPage = ({ component, apiResData, slug, referer, isNew }) => {
	let NewComponent = null;

	NewComponent = components[component];

	return (
		<div id="root">
			{/* <Header /> */}
			<div className="">
				{NewComponent && (
					<NewComponent
						slug={slug}
						data={apiResData}
						referer={referer}
						isNew
					/>
				)}
			</div>
			{/* <Troofooter /> */}
		</div>
	);
};

DynamicPage.getLayout = function getLayout(page, props) {
	return <Layout isNew={props.isNew}>{page}</Layout>;
}
export default DynamicPage;
